var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "#4B57E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "url(#paint0_linear_664_33915)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4192 13.0809C19.2529 12.1853 18.8451 11.3522 18.2399 10.6715C17.6347 9.99075 16.855 9.48828 15.9851 9.21831C15.1152 8.94835 14.188 8.92114 13.3038 9.13964C12.4195 9.35814 11.6117 9.81404 10.9676 10.4581C10.3236 11.1022 9.86766 11.91 9.64917 12.7942C9.43067 13.6785 9.45787 14.6057 9.72783 15.4756C9.9978 16.3455 10.5003 17.1252 11.181 17.7304C11.8617 18.3356 12.6948 18.7434 13.5904 18.9096C13.7567 19.8052 14.1644 20.6383 14.7696 21.319C15.3749 21.9998 16.1545 22.5022 17.0244 22.7722C17.8944 23.0422 18.8215 23.0694 19.7058 22.8509C20.5901 22.6324 21.3978 22.1765 22.0419 21.5324C22.686 20.8883 23.1419 20.0805 23.3604 19.1963C23.5789 18.312 23.5517 17.3849 23.2817 16.5149C23.0118 15.645 22.5093 14.8653 21.8286 14.2601C21.1478 13.6549 20.3147 13.2472 19.4192 13.0809ZM14.7979 16.4953L16.0048 17.7021C15.5285 17.8961 15.0191 17.9957 14.5048 17.9953C14.5043 17.481 14.6039 16.9715 14.7979 16.4953ZM16.9073 17.1909L15.3092 15.5928C15.5354 15.2928 15.8023 15.0258 16.1023 14.7996L17.7004 16.3978C17.4742 16.6977 17.2072 16.9647 16.9073 17.1909ZM18.2117 15.4953L17.0048 14.2884C17.4811 14.0944 17.9905 13.9948 18.5048 13.9953C18.5052 14.5095 18.4057 15.019 18.2117 15.4953ZM10.5048 13.9953C10.5029 13.0203 10.8571 12.0782 11.5009 11.3461C12.1447 10.6139 13.0337 10.1421 14.0009 10.0192C14.9681 9.89643 15.9468 10.1311 16.7532 10.6791C17.5595 11.2271 18.138 12.0508 18.3798 12.9953C17.0978 13.0289 15.8776 13.5535 14.9711 14.4606C14.0645 15.3677 13.5408 16.5882 13.5079 17.8703C12.6489 17.648 11.8881 17.1469 11.3446 16.4456C10.8011 15.7443 10.5057 14.8825 10.5048 13.9953ZM18.5048 21.9953C17.6179 21.9945 16.7564 21.6996 16.0552 21.1567C15.3539 20.6138 14.8526 19.8536 14.6298 18.9953C15.9123 18.9624 17.1333 18.4382 18.0405 17.531C18.9477 16.6238 19.4719 15.4028 19.5048 14.1203C20.4493 14.3621 21.2729 14.9405 21.8209 15.7469C22.369 16.5532 22.6036 17.532 22.4808 18.4992C22.358 19.4663 21.8861 20.3554 21.154 20.9992C20.4218 21.643 19.4797 21.9972 18.5048 21.9953Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_33915",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B57E2",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.e8f3fe6ab262ef038c67c4b63c2ea3fb.svg";
export { ForwardRef as ReactComponent };